module.exports = __webpack_public_path__ + "static/media/Forest_Stewardship_Council.051a6353.svg";